import { gql, TypedDocumentNode } from "@apollo/client";

import { Blueprint, BlueprintTemplate, QueryBlueprintArgs } from "types/generated";

type FetchBlueprintMigratedTemplateData = {
  blueprint: Pick<Blueprint, "id" | "rawTemplate"> & {
    template: BlueprintTemplate;
  };
};

export const GET_BLUEPRINT_MIGRATED_TEMPLATE: TypedDocumentNode<
  FetchBlueprintMigratedTemplateData,
  QueryBlueprintArgs
> = gql`
  query GetBlueprintMigratedTemplate($id: ID!) {
    blueprint(id: $id) {
      id
      rawTemplate
      template {
        template
        warnings
        errors
      }
    }
  }
`;
